import React, { useState } from 'react';
import styles from "../../Configurations.module.css";
import { Matrices } from './matrices';

const LabSettings = () => {
    const [activeTab, setActiveTab] = useState('matrices');

    const tabs = [
        { id: 'matrices', label: 'Matrices', component: Matrices }
    ];

    const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component || Matrices;

    return (
        <div className={styles.section}>
            <div className={styles.sectionHeader}>
                <h2>Laboratory Settings</h2>
                <p>Configure laboratory-specific settings and master data.</p>
            </div>

            <div className={styles.tabContainer}>
                <div className={styles.tabNav}>
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`${styles.tabButton} ${activeTab === tab.id ? styles.active : ''}`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                <div className={styles.tabContent}>
                    <ActiveComponent />
                </div>
            </div>
        </div>
    );
};

export default LabSettings;
